export default {
  cancel: 'Cancel',
  confirm: 'Confirm',
};
